import { detectCoreFeatures } from "@main/infra/feature-detection";
import { Navigate } from "@solidjs/router";

/**
 * §4.4 非対応案内画面。 セッション開始時に `startSessionFlow` がコア機能 (Document PiP API /
 * getUserMedia / WebGL2) を検出し、 欠落があればこの `/unsupported` route へ navigate する
 * (起動時の全画面ブロックは廃止。 非対応環境でも履歴閲覧は可能 = 権限拒否ブランチと対称)。
 *
 * route component は props を取れないため、 欠落機能名はここで再検出する。 直リンクや機能が
 * 揃った環境からの誤遷移に備え、 全機能 OK ならホームへ戻す。
 */
export default function UnsupportedPage() {
  const support = detectCoreFeatures();
  if (support.ok) return <Navigate href="/" />;

  return (
    <main class="mx-auto max-w-4xl space-y-4 px-4 py-12">
      <header class="space-y-2">
        <h1 class="text-2xl font-bold">この環境では動作できません</h1>
        <p class="text-sm opacity-80">
          くちピタは Chrome / Edge デスクトップ最新版で動作します。 以下の機能が利用できないため、
          コア機能を実行できません。
        </p>
      </header>
      <ul class="list-disc rounded-lg bg-surface-2 p-4 pl-8 text-sm">
        {support.missing.map((m) => (
          <li>{m}</li>
        ))}
      </ul>
      <p class="text-sm opacity-80">
        上記が揃ったブラウザで{" "}
        <a href="/" class="text-accent underline">
          再アクセス
        </a>{" "}
        してください。
      </p>
    </main>
  );
}
